<template>
  <div class="accountManagement">
    <signboard :signboardName="signboardName"></signboard>
    <!-- 表格 -->
    <div class="list">
      <el-form :inline="true" size="small" style="float: left;">
        <el-form-item label="对账单号:">
          <el-input
            style="width:290px;"
            v-model="numbers"
            placeholder="请输入对账单号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        style="width: 100%"
        fit
        :loading="isDownloading"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <!-- 表格列定义保持不变 -->
        <el-table-column label="序号" type="index" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="对账单号" prop="statBillNo">
          <template slot-scope="scope">
            <span>{{ scope.row.statBillNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文件名称" prop="fileName" width="400">
          <template slot-scope="scope">
            <span>{{ scope.row.fileName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文件大小" prop="size">
          <template slot-scope="scope">
            <span>{{ scope.row.size }} KB</span>
          </template>
        </el-table-column>
        <el-table-column label="下载时间" prop="downloadTime">
          <template slot-scope="scope">
            <span>{{ scope.row.downloadTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="文件下载状态" prop="status">
          <template slot-scope="scope">
            <span>{{ fileDownloadStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              :disabled="scope.row.status != 'completed'"
              @click="viewFile(scope.row)"
              size="medium"
            >
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import signboard from "@/components/signboard";
import API from "../../../api/bill";
const api = new API();
export default {
  name: "asyncDileDownload",
  components: { signboard },
  data() {
    return {
      signboardName: "异步文件管理",
      tableData: [],
      numbers: "",
      isDownloading: false,
      intervalTimer: null,
      pollingEnabled: true, // 轮询控制标志
    };
  },

  mounted: function() {
    this.startPolling();
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    this.stopPolling();
  },
  methods: {
    onSearch() {
      this.pollingEnabled = true; // 重新启用轮询
      this.startPolling();
    },
    fileDownloadStatus(status) {
      switch (status) {
        case "completed":
          return "已完成";
        case "upload":
          return "进行中";
        case "failed":
          return "下载失败";
        default:
          return "";
      }
    },

    // 查看文件
    async viewFile(file) {
      if (file.status != "completed") {
        this.$message({
          message: "文件正在后台下载中，请稍后再试！",
          type: "warning",
        });
        return;
      }
      // 调用下载接口，获取文件流
      let res = await api.downloadPCStatBillFile({ id: file.id });
      let link = document.createElement("a");
      let blogw = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
      link.href = objectUrl;
      link.download = decodeURI(
        escape(
          res.headers["content-disposition"].replace("attachment;filename=", "")
        )
      );
      link.click();
    },
    async loadFileList() {
      if (!this.isDownloading) {
        this.isDownloading = true;
      }
      try {
        let formData = {
          customerCode:
            window.localStorage.getItem("customerCode") || "401269934",
          statementNo: this.numbers,
        };
        let res = await api.queryPCStatBillFile(formData);
        if (res.success && Array.isArray(res.datalist)) {
          this.tableData = res.datalist.map((file) => ({
            ...file,
            ...this.parseAttachmentInfo(file.attachmentInfo),
            downloadTime: this.formatTimestamp(
              this.parseAttachmentInfo(file.attachmentInfo).createDate || ""
            ),
          }));
          console.log(this.tableData);
          // 检查是否应该停止轮询
          this.checkAndStopPolling();
        }
      } finally {
        this.isDownloading = false; // 无论成功还是失败都设置为false
      }
    },
    // 解析附件信息
    parseAttachmentInfo(attachmentInfo) {
      if (!attachmentInfo) return {};
      if (typeof attachmentInfo === "string") {
        return JSON.parse(attachmentInfo);
      }
      return {};
    },

    // 检查并决定是否停止轮询
    checkAndStopPolling() {
      // 如果数据为空，停止轮询
      if (this.tableData.length === 0) {
        this.stopPolling();
        return;
      }
      // 检查是否所有文件状态都是 completed 或失败
      const allCompleted = this.tableData.every(
        (file) => file.status == "completed" || file.status == "failed"
      );
      // 如果所有文件都已完成，停止轮询
      if (allCompleted) {
        this.stopPolling();
      }
    },
    // 开始定时轮询
    startPolling() {
      // 先停止现有的轮询
      this.stopPolling();

      // 重新启用轮询
      this.pollingEnabled = true;
      // 立即执行一次加载
      this.loadFileList();
      this.intervalTimer = setInterval(() => {
        if (this.pollingEnabled) {
          this.loadFileList();
        }
      }, 3000); // 30秒
    },
    // 停止定时轮询
    stopPolling() {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
        this.intervalTimer = null;
      }
      this.pollingEnabled = false;
    },

    // 时间戳格式化函数
    formatTimestamp(timestamp) {
      if (!timestamp) return "";
      try {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.accountManagement {
  width: 100%;
  height: 100%;
  /deep/.row .el-button {
    padding: 0;
  }
  .list {
    width: 100%;
    padding: 0 32px;
    .vertical-bar {
      margin-top: 8px;
      width: 13px;
      height: 20px;
      font-size: 14px;
      color: #d6d6d6;
      line-height: 20px;
    }
  }
}
</style>
